<div *ngIf="loading">
  <div class="loader"></div>
</div>
